<template>
  <div v-if="displayDescription" :id="descriptionId || undefined" class="form-field-description">{{ displayDescription }}</div>
</template>

<script>
import { visibleFieldDescription } from '../../../shared/form-field-description.js'

export default {
  name: 'FormFieldDescription',
  props: {
    description: { type: String, default: '' },
    descriptionId: { type: String, default: '' }
  },
  computed: {
    displayDescription () {
      return visibleFieldDescription(this.description)
    }
  }
}
</script>

<style>
.form-field-description {
  margin-top: 0.25rem;
  font-size: 0.875rem;
  line-height: 1.4;
  color: #6c757d;
}
</style>
